module.exports = __webpack_public_path__ + "static/img/t4.887e4dce.png";